const cathodeData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133790/assets/data-reports/price-assessments/benchmarkminerals_Graphs_and_charts_photorealistic_realistic_sh_b618f3c7-6778-4a79-8040-ab977633ec26_ecp1pl.png',
  priceAssessmentsBrochureFile: {
    file_name: 'Benchmark-Cathode-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'cathodePriceAssessmentsMethodologyId',
  },
  marketAssessmentsBrochureFile: {
    file_name: 'Benchmark-Cathode-Price-Assessment-Methodology.pdf',
    category: 'methodology-price-assessments',
    EnvKey: 'cathodePriceAssessmentsMethodologyId',
  },
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureCathodeFilePdfId',
    file_name: 'Cathode Forecast Brochure.pdf',
    category: 'public-documents',
  },
  banner: {
    title:
      'Our annual Cathode Forecast service includes a comprehensive cathode supply model updated on a quarterly basis:',
    descriptions: [
      {
        items: [
          '<strong>Plant-by-plant:</strong> MWh and tpa production data for every global cathode active material facility through to 2040',
          '<strong>Chemistry focus:</strong> Cathode active material production data broken down by chemistry type',
          '<strong>Expansions:</strong> Track all cathode facility developments',
          '<strong>Customisation:</strong> A highly customisable supply model, including switchable units and adjustable assumptions to implement your own ideas',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto/v1719502633/assets/market/cathode/prices/benchmarkminerals_batteries_photo_photorealistic_Hyper-realism__6977377b-088a-48be-a434-cbbbb8e9f61b_bkxstv.png?_i=AA',
        alt: 'Cathodes Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto/v1719503457/assets/market/cathode/data-reports/benchmarkminerals_battery_factory_batteriesphotorealistic_reali_d164dd76-6f62-4976-85ae-1e74620c4feb_fowbi9.png?_i=AA',
        alt: 'Cathodes Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto/v1719503457/assets/market/cathode/data-reports/benchmarkminerals_A_high-tech_battery_storage_facility_with_row_50e43d85-15b5-4dcc-b9dd-6256d158d5ab_bgsecr.png?_i=AA',
        alt: 'Cathodes Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_700,f_auto/v1719503457/assets/market/cathode/data-reports/benchmarkminerals_Photograph_of_an_electric_vehicle_battery_pro_e3f49c5d-fc7c-43bb-a4e2-5c110b9b5e58_rmuhrr.png?_i=AA',
      title:
        'Benchmark’s Cathode Forecast features detailed data and analysis for cathode active material:',
      descriptions: [
        {
          items: [
            '<p class="mb-4"><strong>Market balances:</strong> Compare Cathode market balances by chemistry, tier and geography for a thorough view of the market</p>',
            '<p class="mb-4"><strong>Demand drivers:</strong> Chemistry-specific demand breakdowns for the EV, Stationary and Portable lithium-ion battery sectors out to 2040</p>',
            '<p class="mb-4"><strong>Regional perspectives:</strong> Observe cathode supply and demand by region for a geographical view of the market</p>',
            '<p class="mb-4"><strong>Developments:</strong> Track key investments, partnerships and announcements over each quarter</p>',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_500,f_auto/v1719503558/assets/market/cathode/data-reports/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_3fc329a4-f738-4b47-ae32-d252c3e69aef_m70mmg.png?_i=AA',
      title:
        'You will receive full, unrestricted access to the data behind Benchmark’s Cathode Forecast:',
      descriptions: [
        {
          items: [
            '<p class="mb-4"><strong>Online:</strong> accessible downloads available each quarter</p>',
            '<p class="mb-4"><strong>Clear and Concise:</strong> Your data is presented in Excel and pdf format</p>',
            '<p class="mb-4"><strong>Implement Your Ideas:</strong> Each file is fully customisable so you can input your own assumptions</p>',
          ],
        },
      ],
    },
  },
}
export default cathodeData
